import styled, { css } from 'styled-components';
import { ICON_SIZES } from '../../icon';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { StyledListItem, StyledTypographyListItem, getVariantSpecificStyles, iconItemStyles, } from './list-item.styled';
const lightColorThemeStyles = css `
	color: currentcolor;

	&::before {
		background-color: currentcolor;
	}
`;
export const listStyles = ({ $variant, $iconColor, $iconSize, $colorTheme, $outsideSpacing, theme, }) => {
    const paddingLeft = ICON_SIZES[$iconSize || 'xxxl'] + parseInt(theme.uiSize.default, 10);
    return css `
		margin: 0;
		padding: 0;
		list-style: none;

		${$colorTheme === 'light' &&
        css `
			color: ${theme.colors.blanc.textInverse};
		`}

		&:not(:last-child) {
			margin-bottom: ${pxToRem(theme.paragraphSpacing[300])};
		}

		${($variant === 'bulleted' || $variant === 'numbered') &&
        css `
			list-style-type: ${$variant === 'bulleted' ? 'disc' : 'decimal'};
		`}

		> ${StyledListItem} {
			${getVariantSpecificStyles($variant, theme, $iconColor)}

			${$colorTheme === 'light' && lightColorThemeStyles}
		}

		> ${StyledTypographyListItem} {
			${getVariantSpecificStyles($variant, theme, $iconColor)}
			${$colorTheme === 'light' && lightColorThemeStyles}
		}

		${$variant === 'icons' &&
        css `
			> ${StyledListItem} {
				${iconItemStyles};
				padding-left: ${pxToRem(paddingLeft)};
				${$colorTheme === 'light' && lightColorThemeStyles}
			}

			> ${StyledTypographyListItem} {
				${iconItemStyles};
				padding-left: ${pxToRem(paddingLeft)};
				${$colorTheme === 'light' && lightColorThemeStyles}
			}
		`}

		${$outsideSpacing === false &&
        css `
			&:first-child {
				padding-top: 0;

				::before {
					top: 2px;
				}
			}
			${StyledListItem}:first-of-type {
				padding-top: 0;

				::before {
					top: 2px;
				}
			}
		`};
	`;
};
export const StyledList = styled.ul `
	${listStyles}
`;
